import { MARKETS } from '~/utils/consts'

export enum COPY_KEY {
  De = 'de',
  Cz = 'cz',
  Pl = 'pl',
}

export type ClubConfig = {
  copyKey: COPY_KEY
  supportEmail: string
  defaultPhoneNumberCountry: MARKETS
  allowRedirectToFestivalsListing: boolean
}
